import { createFileRoute } from "@tanstack/react-router";

import { OnboardingAnswersPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/onboarding-answers")({
  component: OnboardingAnswersPage,
});
